import { EpiPage } from '@api/types';
import { ContentArea } from '@components';

export type StandardPageContentProps = {
  page?: EpiPage;
};

export const StandardPageContent = ({ page = {} }: StandardPageContentProps) => {
  const { content } = page;
  return <ContentArea content={content} enableNativeOverlay />;
};
